/**
 * When the user drags one handle past another, rc-slider can hand off the drag.
 * Swaps the two stops in the order array so positions stay consistent.
 * Returns a new array if a swap was done, otherwise the same reference.
 */
export function swapOrderOnCross(prev, next, currentOrder, dragStartId) {
  if (dragStartId == null) {
    return currentOrder;
  }

  const n = next.length;

  for (let i = 0; i < n; i += 1) {
    if (prev[i] !== next[i] && currentOrder[i] !== dragStartId) {
      const dragIdx = currentOrder.indexOf(dragStartId);

      if (dragIdx !== -1) {
        const newOrder = [...currentOrder];
        newOrder[i] = currentOrder[dragIdx];
        newOrder[dragIdx] = currentOrder[i];
        return newOrder;
      }

      break;
    }
  }
  return currentOrder;
}
